import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { LayerFeatureFilter } from "../../../model/layer-feature-filter";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "phoenix-feature-data",
  templateUrl: "./feature-data.component.html",
  styleUrls: ["./feature-data.component.scss"],
  standalone: false,
})
export class FeatureDataComponent implements OnInit {
  private _feature: any;

  private _primaryField: string;

  private _secondaryField: string;

  private _layerFeatureFilter: LayerFeatureFilter;

  private _focusedFeature: any;

  focus: boolean = false;

  hover: boolean = false;

  primaryFieldHighlight: boolean = false;

  secondaryFieldHighlight: boolean = false;

  get feature(): any {
    return this._feature;
  }

  @Input() set feature(value: any) {
    this._feature = value;
  }

  get primaryField(): string {
    return this._primaryField;
  }

  @Input() set primaryField(value: string) {
    this._primaryField = value;
  }

  get secondaryField(): string {
    return this._secondaryField;
  }

  @Input() set secondaryField(value: string) {
    this._secondaryField = value;
  }

  get layerFeatureFilter(): LayerFeatureFilter {
    return this._layerFeatureFilter;
  }

  @Input() set layerFeatureFilter(value: LayerFeatureFilter) {
    this._layerFeatureFilter = value;
    this.checkHighlightField();
  }

  get focusedFeature(): any {
    return this._focusedFeature;
  }

  @Input() set focusedFeature(value: any) {
    this._focusedFeature = value;
    this.focus = this.focusedFeature === this.feature;
  }

  @Output() selectFeature = new EventEmitter<any>();

  selected: false;

  ngOnInit(): void {}

  fitFeature() {
    this.selectFeature.emit(this.feature);
  }

  checkSearchValue(propertyValue, searchValue) {
    if (propertyValue && searchValue) {
      return propertyValue.toString().includes(searchValue);
    } else {
      return false;
    }
  }

  checkHighlightField() {
    if (this.layerFeatureFilter?.propertyFilter && this.layerFeatureFilter?.searchValue) {
      this.primaryFieldHighlight =
        this.primaryField &&
        this.layerFeatureFilter.propertyFilter === this.primaryField &&
        this.checkSearchValue(this.feature.properties[this.primaryField], this.layerFeatureFilter.searchValue);
      this.secondaryFieldHighlight =
        this.secondaryField &&
        this.layerFeatureFilter.propertyFilter === this.secondaryField &&
        this.checkSearchValue(this.feature.properties[this.secondaryField], this.layerFeatureFilter.searchValue);
    } else if (this.layerFeatureFilter?.propertyFilter) {
      this.primaryFieldHighlight = this.primaryField && this.layerFeatureFilter.propertyFilter === this.primaryField;
      this.secondaryFieldHighlight =
        this.secondaryField && this.layerFeatureFilter.propertyFilter === this.secondaryField;
    } else if (this.layerFeatureFilter?.searchValue) {
      this.primaryFieldHighlight =
        this.primaryField &&
        this.checkSearchValue(this.feature.properties[this.primaryField], this.layerFeatureFilter.searchValue);
      this.secondaryFieldHighlight =
        this.secondaryField &&
        this.checkSearchValue(this.feature.properties[this.secondaryField], this.layerFeatureFilter.searchValue);
    }
  }
}
